import React from 'react';


class AnnotationAbout extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div></div>
    );
  }
}


export default AnnotationAbout;



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/components/AnnotationAbout.js
 **/